import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchAreas } from '@/features/areas/api'
import { fetchSyadateContract } from '@/features/contracts/api'
import { contractParamsSchema } from '@/routes/_protected/$tenantKey/settings/contracts/-models'

// 車建の契約マスタ
export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/contracts/charter/$contractId'
)({
  parseParams: (params) => parse(contractParamsSchema, params),
  loader: async ({
    abortController,
    params: { tenantKey, contractId },
    context: { auth }
  }) => {
    const [contract, areaSelectList] = await Promise.all([
      fetchSyadateContract({ tenantKey, contractId }, abortController.signal),
      fetchAreas({ tenantKey }, abortController.signal)
    ])
    return {
      authUser: auth.user,
      contract,
      areaSelectList
    }
  },
  meta: ({ loaderData }) => [
    {
      title: loaderData.contract.name
    }
  ]
})
